module.exports = __webpack_public_path__ + "img/well4.b767837f.png";